import { CHANGE_LIST_PARAMS } from '@/state/types/list'

export default (resource, options) => {
  // Add non enumerable `default` holding initial query parameters
  function addSilentDefault(obj) {
    Object.defineProperty(obj, 'default', {
      value: { ...options.defaultParams },
    }) // non enumerable by default
    return obj
  }
  const initialState = addSilentDefault(options.defaultParams || {})

  return (previousState = initialState, { type, payload, meta }) => {
    if (meta && meta.resource !== resource) {
      return previousState
    } else if (meta && meta.location && meta.query) {
      return addSilentDefault({ ...previousState, ...meta.query })
    }
    switch (type) {
      case CHANGE_LIST_PARAMS:
        return addSilentDefault(payload)
      default:
        return previousState
    }
  }
}



// WEBPACK FOOTER //
// ./state/reducers/resource/list/params.js